export enum SocialStatus {
    IDLE = 'idle',
    SIGNED = 'signed',
    UNSIGNED = 'unsigned',
    NO_PROFILES = 'no profiles'
}
